import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { CONFIG } from '@domgen/dgx-fe-config';
import { FloorcareProviderNames } from '../../constants/floorcare-provider-names.enum';
import { AppConfig } from '../../models/config/app-config.type';
import { FeatureFlagService } from '../../services/feature-flag.service';

@Component({
  selector: 'dg-my-account-banner',
  templateUrl: './my-account-banner.component.html',
  styleUrls: ['./my-account-banner.component.scss'],
})
export class MyAccountBannerComponent implements OnInit, OnChanges {
  @Input() isRepairClaim?: boolean = true;
  @Input() isWhirlpoolBooking = false;

  @Input() isGadget: boolean = false;
  @Input() serviceOptionType: string | undefined;
  @Input() pageName = '';
  @Input() planNumber = '';
  @Input() productBrand = '';
  @Input() productType = '';
  @Input() isFloorcareProduct = false;
  @Input() serviceProviderCompanyName = '';

  @Input() gadgetType: 'APPLE' | 'GADGET' | undefined;

  heading = '';
  navigationLink: NavigationLink = {
    href: '',
    label: '',
  };
  productName = '';

  constructor(@Inject(CONFIG) private readonly config: AppConfig) {}

  ngOnInit(): void {
    this.updateHeading();
    this.updateNavigationLink();
    this.productName =
      `${this.productBrand?.toLowerCase()} ${this.productType?.toLowerCase()}`.trim();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.isRepairClaim ||
      changes.planNumber ||
      this.isWhirlpoolBooking
    ) {
      this.updateNavigationLink();
      this.updateHeading();
    }
  }

  private updateNavigationLink(): void {
    this.navigationLink = {
      href: `${this.config?.plansHomePage}/${this.planNumber}/claims`,
      label: `Manage my ${this.isRepairClaim ? 'repair' : 'service'}`,
    } as NavigationLink;
  }

  private updateHeading(): void {
    if (this.isFloorcareProduct) {
      const providerNameLowerCased =
        this.serviceProviderCompanyName.toLowerCase();

      if (
        providerNameLowerCased === FloorcareProviderNames.NORTH_WEST_APPLIANCE
      ) {
        this.heading = 'View your collection and repair details';
      } else {
        this.heading = 'View your repair details';
      }

      return;
    }

    if (this.serviceOptionType === 'selfSend') {
      this.heading = 'View or change your repair details';
      return;
    }

    if (this.serviceOptionType === 'dropOff') {
      if (this.gadgetType === 'GADGET') {
        this.heading = 'View or change your drop-off and repair details';
        return;
      }
      this.heading = 'View your repair details';
      return;
    }
    if (this.serviceOptionType === 'selfFit') {
      this.heading = 'Check your booking details anytime';
      return;
    }

    if (this.isGadget) {
      this.heading = 'View or change your collection and repair details';
      return;
    }
    if (this.isWhirlpoolBooking) {
      this.heading = 'View details, change booking and track your engineer';
      return;
    }

    this.heading = 'View details, change or cancel your booking';
  }
}
